import React from 'react';
import { makeStyles } from '@mui/styles';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import Delete from '@mui/icons-material/Delete';
import { connect } from 'react-redux'

import { moveDown, moveUp, selectRowDown, selectRowUp, deleteRow, clearRowSelection } from '../../actions';

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(0.5),
    }
}));

const Controls = ({ onMoveDown, onMoveUp, onDelete, row }) => {
    const classes = useStyles();

    return (
        <ButtonGroup orientation="vertical" aria-label="outlined primary button group">
            <Tooltip title="Move element up">
                <IconButton className={classes.button} aria-label="Up" onClick={() => onMoveUp(row.selected)}>
                    <ArrowUpward />
                </IconButton>
            </Tooltip>
            <Tooltip title="Move element down">
                <IconButton className={classes.button} aria-label="Down" onClick={ () => onMoveDown(row.selected)}>
                    <ArrowDownward />
                </IconButton>
            </Tooltip>
            <Tooltip title="Delete element">
                <IconButton className={classes.button} aria-label="Delete" onClick={ () => onDelete(row.selected)}>
                    <Delete />
                </IconButton>
            </Tooltip>
        </ButtonGroup>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        onMoveUp: (rowId) => {
            dispatch(moveUp({ rowId }));
            // dispatch(selectRowUp({ rowId }));
        },
        onMoveDown: (rowId) => {
            dispatch(moveDown({ rowId }));
            // dispatch(selectRowDown({ rowId }));
        },
        onDelete: (rowId) => {
            dispatch(deleteRow({ rowId }));
            dispatch(clearRowSelection());
        }
    }
}

const mapStateToProps = (state) => {
    return {
        row: state.row
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Controls);